export default class CsCacheResources {

  constructor(debugHandler, getCache, setCache, removeCache, forceRefresh) {
    this.debugHandler = debugHandler;
    this.getCache = getCache;
    this.setCache = setCache;
    this.removeCache = removeCache;
    this.forceRefresh = forceRefresh;
  }

  /**
   * @returns {Promise<unknown>|Promise<[]>}
   */
  loadResources = () => {
    const resources = this.getCache(this._cacheKey());
    if (resources && Array.isArray(resources) && !this.forceRefresh) {
      return Promise.resolve(resources);
    } else {
      return this.requestExternalResources();
    }
  }

  /**
   * @returns {Promise<*[]>}
   */
  requestExternalResources = () => {
    return Promise.resolve([]);
  }

  _cacheKey = () => {
    return 'cache_key';
  }
}